module.exports = __webpack_public_path__ + "img/Vkusvil.e2bbe8aa.png";